<template>
    <div id="FormMeeting">
        <div class="form-meeting">
            <h3>Randevu</h3>
        </div>
    </div>
</template>
<script>
export default {
    name: "FormMeeting",
};
</script>
<style lang="scss" scoped>
#FormMeeting{

}
</style>
